import { Component } from "@theme/component";
import { EVENTS } from "./constants";

class CompareToggle extends Component {
  requiredRefs = ["checkbox"];

  #unsubscribeProductsChange: (() => void) | undefined;
  #unsubscribeInit: (() => void) | undefined;

  connectedCallback(): void {
    super.connectedCallback();
    this.#subscribe();
  }

  updatedCallback(): void {
    super.updatedCallback();
    this.#handleProductsChange(
      window.vehicleManager.comparison?.getProducts() ?? [],
    );
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.#unsubscribeProductsChange?.();
    this.#unsubscribeInit?.();
  }

  #subscribe() {
    // remove existing subscriptions if set
    this.#unsubscribeProductsChange?.();
    this.#unsubscribeInit?.();
    // create new subscriptions
    this.#unsubscribeProductsChange = window.vehicleManager.pubsub.subscribe(
      EVENTS.comparisonProductsChange,
      this.#handleProductsChange.bind(this),
      { replayLast: true },
    );
    this.#unsubscribeInit = window.vehicleManager.pubsub.subscribe(
      EVENTS.comparisonInit,
      this.#handleComparisonInit.bind(this),
      { replayLast: true },
    );
  }

  #handleComparisonInit() {
    this.hidden = false;
  }

  #handleProductsChange(handles: string[]) {
    if (!window.vehicleManager.comparison) return;

    const productHandle = this.dataset.productHandle ?? "";
    const checkbox = this.refs.checkbox as HTMLInputElement;

    const active = handles.includes(productHandle);

    if (active) {
      checkbox.checked = true;
    } else {
      checkbox.checked = false;
    }

    // Disable checkbox if we are at the comparison limit
    const limit = window.vehicleManager.comparison.productsLimit;
    if (handles.length >= limit && !active) {
      checkbox.disabled = true;
    } else {
      checkbox.disabled = false;
    }
  }

  handleClick(e: Event) {
    e.preventDefault();
    if (!window.vehicleManager.comparison) return;

    const productHandle = this.dataset.productHandle ?? "";
    const checkbox = this.refs.checkbox as HTMLInputElement;

    // skip if disabled
    if (checkbox.disabled) return;

    // Note: checkbox state is updated by handleProductsChange
    if (checkbox.checked) {
      window.vehicleManager.comparison.removeProduct(productHandle);
    } else {
      window.vehicleManager.comparison.addProduct(productHandle);
    }
  }
}

if (!customElements.get("compare-toggle")) {
  customElements.define("compare-toggle", CompareToggle);
}
